import { Input, Select, Checkbox, Space } from 'antd';

interface SearchFilterBarProps {
  searchText: string;
  onSearchTextChange: (value: string) => void;
  entityType: string;
  onEntityTypeChange: (value: string) => void;
  roleFilter?: string;
  onRoleFilterChange?: (value: string | undefined) => void;
  missingDocs?: boolean;
  onMissingDocsChange?: (value: boolean) => void;
  highRejection?: boolean;
  onHighRejectionChange?: (value: boolean) => void;
  societyTypeFilter?: string;
  onSocietyTypeFilterChange?: (value: string | undefined) => void;
  societyStatusFilter?: string;
  onSocietyStatusFilterChange?: (value: string | undefined) => void;
  missingSiret?: boolean;
  onMissingSiretChange?: (value: boolean) => void;
  refusedDocs?: boolean;
  onRefusedDocsChange?: (value: boolean) => void;
  interventionStatusFilter?: string;
  onInterventionStatusFilterChange?: (value: string | undefined) => void;
  onSearch: () => void;
}

const ENTITY_TYPES = [
  { value: 'users', label: 'Utilisateurs' },
  { value: 'societies', label: 'Sociétés' },
  { value: 'interventions', label: 'Interventions' },
  { value: 'not-registered-agents', label: 'Agents non enregistrés' },
];

const USER_ROLES = [
  { value: 'CLIENT', label: 'Client' },
  { value: 'AGENT', label: 'Agent' },
  { value: 'SOCIETY_OWNER', label: 'Patron' },
  { value: 'ADMIN', label: 'Admin' },
];

const SOCIETY_TYPES = [
  { value: 'SECURITY', label: 'Sécurité' },
  { value: 'INSTALLER', label: 'Installateur' },
  { value: 'DISTRIBUTOR', label: 'Distributeur' },
];

const SOCIETY_STATUSES = [
  { value: 'PENDING', label: 'En attente' },
  { value: 'VALIDATED', label: 'Validé' },
  { value: 'REJECTED', label: 'Refusé' },
  { value: 'WAITING_ON_INFORMATION', label: 'En attente d\'info' },
];

const INTERVENTION_STATUSES = [
  { value: 'REQUESTED', label: 'Demandé' },
  { value: 'ACCEPTED', label: 'Accepté' },
  { value: 'AGENT_MOVING', label: 'Agent en déplacement' },
  { value: 'INSPECTION_IN_PROGRESS', label: 'Inspection en cours' },
  { value: 'DONE', label: 'Terminé' },
  { value: 'REJECTED', label: 'Refusé' },
  { value: 'CANCELED', label: 'Annulé' },
  { value: 'EFFRACTION', label: 'Effraction' },
  { value: 'NO_EFFRACTION', label: 'Pas d\'effraction' },
];

export function SearchFilterBar({
  searchText,
  onSearchTextChange,
  entityType,
  onEntityTypeChange,
  roleFilter,
  onRoleFilterChange,
  missingDocs,
  onMissingDocsChange,
  highRejection,
  onHighRejectionChange,
  societyTypeFilter,
  onSocietyTypeFilterChange,
  societyStatusFilter,
  onSocietyStatusFilterChange,
  missingSiret,
  onMissingSiretChange,
  refusedDocs,
  onRefusedDocsChange,
  interventionStatusFilter,
  onInterventionStatusFilterChange,
  onSearch,
}: SearchFilterBarProps) {
  return (
    <Space direction="vertical" style={{ width: '100%' }} size="middle">
      <Space wrap style={{ width: '100%' }}>
        <Input.Search
          placeholder="Rechercher..."
          value={searchText}
          onChange={(e) => onSearchTextChange(e.target.value)}
          onSearch={onSearch}
          style={{ width: 300 }}
          allowClear
        />
        <Select
          value={entityType}
          onChange={onEntityTypeChange}
          options={ENTITY_TYPES}
          style={{ width: 200 }}
        />
      </Space>

      {entityType === 'users' && (
        <Space wrap>
          <Select
            value={roleFilter}
            onChange={onRoleFilterChange}
            options={USER_ROLES}
            placeholder="Filtrer par rôle"
            allowClear
            style={{ width: 180 }}
          />
          <Checkbox checked={missingDocs} onChange={(e) => onMissingDocsChange?.(e.target.checked)}>
            Documents manquants
          </Checkbox>
          <Checkbox checked={highRejection} onChange={(e) => onHighRejectionChange?.(e.target.checked)}>
            Taux de rejet élevé
          </Checkbox>
        </Space>
      )}

      {entityType === 'societies' && (
        <Space wrap>
          <Select
            value={societyTypeFilter}
            onChange={onSocietyTypeFilterChange}
            options={SOCIETY_TYPES}
            placeholder="Type de société"
            allowClear
            style={{ width: 180 }}
          />
          <Select
            value={societyStatusFilter}
            onChange={onSocietyStatusFilterChange}
            options={SOCIETY_STATUSES}
            placeholder="Statut"
            allowClear
            style={{ width: 180 }}
          />
          <Checkbox checked={missingSiret} onChange={(e) => onMissingSiretChange?.(e.target.checked)}>
            SIRET manquants
          </Checkbox>
          <Checkbox checked={refusedDocs} onChange={(e) => onRefusedDocsChange?.(e.target.checked)}>
            Documents refusés
          </Checkbox>
        </Space>
      )}

      {entityType === 'interventions' && (
        <Space wrap>
          <Select
            value={interventionStatusFilter}
            onChange={onInterventionStatusFilterChange}
            options={INTERVENTION_STATUSES}
            placeholder="Statut d'intervention"
            allowClear
            style={{ width: 200 }}
          />
        </Space>
      )}
    </Space>
  );
}
